import React, { lazy } from 'react';
import { Utensils as UtensilsIcon, ShoppingBag as BagIcon, Clock as ClockIcon, Sparkles as SparklesIcon } from 'lucide-react';
const Features = () => {
  return <section className="py-16 bg-amber-50" data-id="element-64">
      <div className="container mx-auto px-4" data-id="element-65">
        <div className="text-center mb-8" data-id="element-66">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800" data-id="element-67">
            Lo que encontrarás dentro
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-68">
            Un sistema completo para transformar tus cenas diarias en
            experiencias deliciosas sin complicaciones
          </p>
        </div>
        {/* Imagen de mujer cocinando */}
        <div className="max-w-3xl mx-auto mb-12" data-id="element-69">
          <div className="img-container aspect-ratio-16-9 shadow-lg rounded-lg" data-id="element-70">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k69m6MPgVasKG23radg4Z6/Lo_que_entontraras_2.jpg" alt="Mujer cocinando con tablet" className="img-content" width="800" height="450" loading="lazy" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://via.placeholder.com/800x450/f5f5f5/a97142?text=Mujer+Cocinando';
          }} data-id="element-71" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12" data-id="element-72">
          <div className="flex items-start p-6 bg-white rounded-lg shadow-md" data-id="element-73">
            <div className="bg-custom-brown bg-opacity-20 p-3 rounded-full mr-4" data-id="element-74">
              <UtensilsIcon className="text-custom-brown" size={24} data-id="element-75" />
            </div>
            <div data-id="element-76">
              <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-77">
                7 recetas latinas paso a paso
              </h3>
              <p className="text-gray-600" data-id="element-78">
                Desde tacos al pastor hasta arroz con pollo, cada receta está
                detallada con instrucciones claras y fotos para guiarte en cada
                paso.
              </p>
            </div>
          </div>
          <div className="flex items-start p-6 bg-white rounded-lg shadow-md" data-id="element-79">
            <div className="bg-custom-brown bg-opacity-20 p-3 rounded-full mr-4" data-id="element-80">
              <BagIcon className="text-custom-brown" size={24} data-id="element-81" />
            </div>
            <div data-id="element-82">
              <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-83">
                Lista de compras optimizada
              </h3>
              <p className="text-gray-600" data-id="element-84">
                Organizadas por sección del supermercado para ahorrar tiempo y
                dinero, aprovechando al máximo cada ingrediente.
              </p>
            </div>
          </div>
          <div className="flex items-start p-6 bg-white rounded-lg shadow-md" data-id="element-85">
            <div className="bg-custom-brown bg-opacity-20 p-3 rounded-full mr-4" data-id="element-86">
              <ClockIcon className="text-custom-brown" size={24} data-id="element-87" />
            </div>
            <div data-id="element-88">
              <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-89">
                Batch cooking en 2 horas
              </h3>
              <p className="text-gray-600" data-id="element-90">
                Prepara los ingredientes base el domingo y ahorra hasta 5 horas
                durante la semana. Te explicamos exactamente qué hacer y cuándo.
              </p>
            </div>
          </div>
          <div className="flex items-start p-6 bg-white rounded-lg shadow-md" data-id="element-91">
            <div className="bg-custom-brown bg-opacity-20 p-3 rounded-full mr-4" data-id="element-92">
              <SparklesIcon className="text-custom-brown" size={24} data-id="element-93" />
            </div>
            <div data-id="element-94">
              <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-95">
                Variaciones creativas
              </h3>
              <p className="text-gray-600" data-id="element-96">
                Para cada receta te damos 3 variaciones diferentes para que
                nunca te aburras y puedas adaptar según lo que tengas
                disponible.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-12" data-id="element-97">
          <div className="flex flex-col sm:flex-row items-center justify-center" data-id="element-98">
            <a href="https://pay.hotmart.com/W101891326K?checkoutMode=10" className="bg-white text-custom-brown hover:bg-custom-brown hover:text-white border border-custom-brown font-bold py-3 px-8 rounded-lg text-lg transition duration-300 shadow-lg" onClick={() => {
            if (window.fbq) window.fbq('track', 'AddToCart', {
              content_name: '7 Cenas Latinas en 30 Minutos',
              content_type: 'product',
              value: 7.0,
              currency: 'USD'
            });
          }} data-id="element-99">
              Descargar mi copia ahora - $7.00
            </a>
          </div>
          <p className="mt-3 text-custom-brown font-medium" data-id="element-100">
            <del className="text-gray-500" data-id="element-101">$83</del> - ahorras $77
          </p>
        </div>
      </div>
    </section>;
};
export default Features;